import { useEffect } from "react"

import { ABTestContainer, AB_TESTS } from "@trueskin-web/ab-experiments"
import { marketingClient } from "@trueskin-web/apis"
import { Seo, Spinner } from "@trueskin-web/components"
import i18next, { Trans } from "@trueskin-web/translations"

import {
  AntiAgingPlanSelectionV1,
  AntiAgingPlanSelectionV2,
} from "../../ab-experiments/anti-aging-plan-selection-redesign"
import usePreferredPreset from "../../hooks/use-preferred-preset"

import AntiAging from "./anti-aging/anti-aging"
import withPresetsData from "./components/with-presets-data"
import ChoosePlanCore from "./core/choose-plan-core"

// TODO: @eduard: clean up after A/B test is concluded AG-665
const ANTI_AGING_PRESET = ["main_anti_aging", "main_anti_aging_AG_665_exp"]

export const ChoosePlan = ({ presetList, isLoading, error }) => {
  const { preferredPreset } = usePreferredPreset()
  const enableAntiAging = ANTI_AGING_PRESET.includes(preferredPreset)

  useEffect(() => {
    if (!isLoading && !error) {
      marketingClient.sendEvent({
        name: marketingClient.EVENT_TYPES_ENUM.PRODUCT_SELECTION_PAGE_OPENED,
      })
    }
  }, [isLoading, error])

  if (isLoading || !preferredPreset) {
    return <Spinner isFullPage />
  }

  if (error) {
    return (
      <span>
        <Trans i18Key="ChoosePlan.errorMessage" message={error.message} />
      </span>
    )
  }

  return (
    <>
      <Seo title={i18next.t("ChoosePlan.seoTitle")} />
      {/*TODO: @eduard: clean up after A/B test is concluded AG-665 */}
      {enableAntiAging ? (
        <ABTestContainer
          testName={AB_TESTS.AntiAgingPlanSelectionRedesign}
          presetList={presetList}
          variants={[
            [1, AntiAgingPlanSelectionV1],
            [2, AntiAgingPlanSelectionV2],
          ]}
          fallbackComponent={AntiAging}
        />
      ) : (
        <ChoosePlanCore presetList={presetList} />
      )}
    </>
  )
}

export default withPresetsData(ChoosePlan)
